import { render, staticRenderFns } from "./QueueBoard.vue?vue&type=template&id=a7293a8c&scoped=true&"
import script from "./QueueBoard.vue?vue&type=script&lang=js&"
export * from "./QueueBoard.vue?vue&type=script&lang=js&"
import style0 from "./QueueBoard.vue?vue&type=style&index=0&id=a7293a8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7293a8c",
  null
  
)

export default component.exports